/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("TabNameVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class TabNameVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.TabNameVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.TabNameVMBehavior.prototype */ {
      __name: "TabNameVMBehavior",

      watchedAttributes: {
        anchor: ["tabName"]
      },
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const bindings = controller.getNodeBindings();
        const node = bindings.container || bindings.anchor;
        const widget = controller.getWidget();
        if (widget?.setTabName) {
          const tabName = node.attribute("tabName");
          widget.setTabName(tabName);
        }
      }
    };
  });
});
